<template>
  <div id="proposta_passo2">
   <el-row type="flex" >
      <el-col :span="24" style="text-align:right" >
        <el-button style="margin-top: 12px; text-align: left;"  type="primary" size="small" round plain @click="anterior" :disabled="disable_left"><i class="el-icon-d-arrow-left"></i> Anterior</el-button>
        <el-button style="margin-top: 12px;"  type="primary" plain round size="small" @click="next" :disabled="disable_right">Próximo <i class="el-icon-d-arrow-right"></i></el-button>
      </el-col>
    </el-row>     
    <el-row>
      <el-col :span="24"><p class="proposta_titulo proposta_centro ">Passo 3 - Proposta Comercial</p></el-col>
    </el-row>
    <el-form :model="ruleForm" :rules="ruleForm" ref="ruleForm">
      <el-row>
        <el-col :span="24">

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Título" prop="titulo_proposta">
          <el-input v-model="ruleForm.titulo_proposta"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Sub-título" prop="subtitulo_proposta">
              <el-input v-model="ruleForm.subtitulo_proposta"></el-input>
          </el-form-item>
        </el-col>
      </el-row>           
          <el-form-item label="" prop="proposta">
            <vue-editor id="proposta" v-model="ruleForm.proposta" :editor-toolbar="customToolbar"></vue-editor>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Título" prop="titulo_impostos">
          <el-input v-model="ruleForm.titulo_valores"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Sub-título" prop="subtitulo_impostos">
              <el-input v-model="ruleForm.subtitulo_valores"></el-input>
          </el-form-item>
        </el-col>
      </el-row>        

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Título" prop="titulo_impostos">
          <el-input v-model="ruleForm.titulo_impostos"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Sub-título" prop="subtitulo_impostos">
              <el-input v-model="ruleForm.subtitulo_impostos"></el-input>
          </el-form-item>
        </el-col>
      </el-row>        
      <el-row>
        <el-col :span="24">
          <el-form-item label="" prop="impostos">
            <vue-editor id="impostos" v-model="ruleForm.impostos" :editor-toolbar="customToolbar"></vue-editor>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Título" prop="titulo_pagamento">
          <el-input v-model="ruleForm.titulo_pagamento"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Sub-título" prop="subtitulo_pagamento">
              <el-input v-model="ruleForm.subtitulo_pagamento"></el-input>
          </el-form-item>
        </el-col>
      </el-row>          
      <el-row>
        <el-col :span="24">
          <el-form-item label="" prop="pagamento">
            <vue-editor id="pagamento" v-model="ruleForm.pagamento" :editor-toolbar="customToolbar"></vue-editor>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Título" prop="titulo_frete">
          <el-input v-model="ruleForm.titulo_frete"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Sub-título" prop="subtitulo_frete">
              <el-input v-model="ruleForm.subtitulo_frete"></el-input>
          </el-form-item>
        </el-col>
      </el-row>          
      <el-row>
        <el-col :span="24">
          <el-form-item label="" prop="frete">
            <vue-editor id="frete" v-model="ruleForm.frete" :editor-toolbar="customToolbar"></vue-editor>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Título" prop="titulo_garantia">
          <el-input v-model="ruleForm.titulo_garantia"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Sub-título" prop="subtitulo_garantia">
              <el-input v-model="ruleForm.subtitulo_garantia"></el-input>
          </el-form-item>
        </el-col>
      </el-row>         
      <el-row>
        <el-col :span="24">
          <el-form-item label="" prop="garantia">
            <vue-editor id="garantia" v-model="ruleForm.garantia" :editor-toolbar="customToolbar"></vue-editor>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Título" prop="titulo_validade">
          <el-input v-model="ruleForm.titulo_validade"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Sub-título" prop="subtitulo_validade">
              <el-input v-model="ruleForm.subtitulo_validade"></el-input>
          </el-form-item>
        </el-col>
      </el-row>          
      <el-row>
        <el-col :span="24">
          <el-form-item label="" prop="validade">
            <vue-editor id="validade" v-model="ruleForm.validade" :editor-toolbar="customToolbar"></vue-editor>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Título" prop="titulo_entrega">
          <el-input v-model="ruleForm.titulo_entrega"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Sub-título" prop="subtitulo_entrega">
              <el-input v-model="ruleForm.subtitulo_entrega"></el-input>
          </el-form-item>
        </el-col>
      </el-row>          
      <el-row>
        <el-col :span="24">
          <el-form-item label="" prop="entrega">
            <vue-editor id="entrega" v-model="ruleForm.entrega" :editor-toolbar="customToolbar"></vue-editor>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Título" prop="titulo_aceite">
          <el-input v-model="ruleForm.titulo_aceite"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Sub-título" prop="subtitulo_aceite">
              <el-input v-model="ruleForm.subtitulo_aceite"></el-input>
          </el-form-item>
        </el-col>
      </el-row>  
      <el-row :gutter="10">
        <el-col :span="12">
          <p style="text-align:left; font-weight: bold;">Assinatura 1:</p>
          <el-form-item label prop="aceite">
            <vue-editor id="aceite" v-model="ruleForm.aceite" :editor-toolbar="customToolbar"></vue-editor>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <p style="text-align:left;font-weight: bold;">Assinatura 2:</p>
          <el-form-item label prop="aceite2">
            <vue-editor id="aceite2" v-model="ruleForm.aceite2" :editor-toolbar="customToolbar"></vue-editor>
          </el-form-item>
        </el-col>
      </el-row>
       {{proposta_id}}
    </el-form>
   
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

import axios from "axios";

export default {
  components: {
    VueEditor,
  },
  props: {
  proposta_id: [Number]
},  
  data() {
    return {
      customToolbar: [
      ["bold", "italic", "underline","strike"],
      [{ list: "ordered" }, { list: "bullet" }]
    ],      
      disable_left: false,
      disable_right: false,        
      ruleForm: {
        titulo_proposta:"",
        subtitulo_proposta:"",
        proposta: "",
        titulo_valores:"",
        subtitulo_valores:"",
        titulo_impostos:"",
        subtitulo_impostos:"",
        impostos: "",
        titulo_pagamento:"",
        subtitulo_pagamento:"",
        pagamento: "",
        titulo_frete:"",
        subtitulo_frete:"",
        frete: "",
        titulo_garantia:"",
        subtitulo_garantia:"",
        garantia: "",
        titulo_validade:"",
        subtitulo_validade:"",
        validade: "",
        titulo_entrega:"",
        subtitulo_entrega:"",
        titulo_aceite:"",
        subtitulo_aceite:"",
        entrega: "",
        aceite: "",
        aceite2: "",
      },
    };
  },
  mounted() {
     let dados = {
        pagina_pagina: "3",
      };
      axios
        .post(url + "/proposta/"+this.proposta_id, dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          if (resp.data.status == "Token is Expired" || resp.data.status == "Token is Invalid" || resp.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
          //  this.ruleForm.apresentacao  = resp.data['pagina'][0].texto;
          for (let i = 0; i < resp.data.pagina.length; i++) {
            switch (resp.data.pagina[i].slug) {
              case "proposta":
                if(resp.data.pagina[i].titulo!='' && resp.data.pagina[i].titulo != undefined)
                    this.ruleForm.titulo_proposta = resp.data.pagina[i].titulo;
                if(resp.data.pagina[i].subtitulo!='' && resp.data.pagina[i].subtitulo != undefined)
                    this.ruleForm.subtitulo_proposta = resp.data.pagina[i].subtitulo;
                this.ruleForm.proposta = resp.data.pagina[i].texto;
                break;
              case "tituloproposta":
                this.ruleForm.titulo_proposta = resp.data.pagina[i].texto;
                break;                
              case "subtituloproposta":
                  this.ruleForm.subtitulo_proposta = resp.data.pagina[i].texto;
                break;                
              case "valores":
                if(resp.data.pagina[i].titulo!='' && resp.data.pagina[i].titulo != undefined)
                  this.ruleForm.titulo_valores = resp.data.pagina[i].titulo;
                if(resp.data.pagina[i].subtitulo != '' && resp.data.pagina[i].subtitulo != undefined)
                  this.ruleForm.subtitulo_valores = resp.data.pagina[i].subtitulo;
                break;                
              case "titulovalores":
                this.ruleForm.titulo_valores = resp.data.pagina[i].texto;
                break;
              case "subtitulovalores":
                  this.ruleForm.subtitulo_valores = resp.data.pagina[i].texto;
                break;                
              case "impostos":
                if(resp.data.pagina[i].titulo!='' && resp.data.pagina[i].titulo != undefined)
                  this.ruleForm.titulo_impostos = resp.data.pagina[i].titulo;
                if(resp.data.pagina[i].subtitulo != '' && resp.data.pagina[i].subtitulo != undefined)
                  this.ruleForm.subtitulo_impostos = resp.data.pagina[i].subtitulo;
                this.ruleForm.impostos = resp.data.pagina[i].texto;
                break;
              case "tituloimpostos":
                this.ruleForm.titulo_impostos = resp.data.pagina[i].texto;
                break;
              case "subtituloimpostos":
                  this.ruleForm.subtitulo_impostos = resp.data.pagina[i].texto;
                break;
              case "pagamento":
                if(resp.data.pagina[i].titulo != '' && resp.data.pagina[i].titulo != undefined)
                  this.ruleForm.titulo_pagamento = resp.data.pagina[i].titulo;
                if(resp.data.pagina[i].subtitulo != '' && resp.data.pagina[i].titulo != undefined)
                  this.ruleForm.subtitulo_pagamento = resp.data.pagina[i].subtitulo;
                this.ruleForm.pagamento = resp.data.pagina[i].texto;
                break;
              case "titulopagamento":
                this.ruleForm.titulo_pagamento = resp.data.pagina[i].texto;
                break;
              case "subtitulopagamento":
                  this.ruleForm.subtitulo_pagamento = resp.data.pagina[i].texto;
                break;
              case "frete":
                if(resp.data.pagina[i].titulo != '' && resp.data.pagina[i].titulo != undefined)
                  this.ruleForm.titulo_frete = resp.data.pagina[i].titulo;
                if(resp.data.pagina[i].subtitulo != '' && resp.data.pagina[i].subtitulo != undefined)
                  this.ruleForm.subtitulo_frete = resp.data.pagina[i].subtitulo;
                this.ruleForm.frete = resp.data.pagina[i].texto;
                break;
              case "titulofrete":
                this.ruleForm.titulo_frete = resp.data.pagina[i].texto;
                break;
              case "subtitulofrete":
                  this.ruleForm.subtitulo_frete = resp.data.pagina[i].texto;
                break;
              case "garantia":
                if(resp.data.pagina[i].titulo != '' && resp.data.pagina[i].titulo != undefined)
                  this.ruleForm.titulo_garantia = resp.data.pagina[i].titulo;
                if(resp.data.pagina[i].subtitulo != '' && resp.data.pagina[i].subtitulo != undefined)
                  this.ruleForm.subtitulo_garantia = resp.data.pagina[i].subtitulo;
                this.ruleForm.garantia = resp.data.pagina[i].texto;
                break;
              case "titulogarantia":
                this.ruleForm.titulo_garantia = resp.data.pagina[i].texto;
                break;
              case "subtitulogarantia":
                  this.ruleForm.subtitulo_garantia = resp.data.pagina[i].texto;
                break;
              case "validade":
                if(resp.data.pagina[i].titulo != '' && resp.data.pagina[i].titulo != undefined)
                  this.ruleForm.titulo_validade = resp.data.pagina[i].titulo;
                if(resp.data.pagina[i].subtitulo != '' && resp.data.pagina[i].subtitulo != undefined)
                  this.ruleForm.subtitulo_validade = resp.data.pagina[i].subtitulo;
                this.ruleForm.validade = resp.data.pagina[i].texto;
                break;
              case "titulovalidade":
                this.ruleForm.titulo_validade = resp.data.pagina[i].texto;
                break;
              case "subtitulovalidade":
                  this.ruleForm.subtitulo_validade = resp.data.pagina[i].texto;
                break;
              case "entrega":
                if(resp.data.pagina[i].titulo != '' && resp.data.pagina[i].titulo != undefined)
                  this.ruleForm.titulo_entrega = resp.data.pagina[i].titulo;
                if(resp.data.pagina[i].subtitulo != '' && resp.data.pagina[i].subtitulo != undefined)
                  this.ruleForm.subtitulo_entrega = resp.data.pagina[i].subtitulo;
                this.ruleForm.entrega = resp.data.pagina[i].texto;
                break;
              case "tituloentrega":
                this.ruleForm.titulo_entrega = resp.data.pagina[i].texto;
                break;  
              case "subtituloentrega":
                  this.ruleForm.subtitulo_entrega = resp.data.pagina[i].texto;
                break;
              case "tituloaceite":
                this.ruleForm.titulo_aceite = resp.data.pagina[i].texto;
                break;  
              case "subtituloaceite":
                  this.ruleForm.subtitulo_aceite = resp.data.pagina[i].texto;
                break;
              case "aceiteproposta":
                  this.ruleForm.titulo_aceite = resp.data.pagina[i].titulo;
                  this.ruleForm.subtitulo_aceite = resp.data.pagina[i].subtitulo;
                break;
              case "aceite":
                this.ruleForm.aceite = resp.data.pagina[i].texto;
                break;
              case "aceite2":
                this.ruleForm.aceite2 = resp.data.pagina[i].texto;
                break;
            }
          }          
          }
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao buscar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });                 

  },

      methods: {
      // next() {
      //   // let active = 3; //próximo Passo
      //   // this.$emit('button-click',active);
      // },
 next() {

      if(this.ruleForm.subtitulo_proposta==null){
        this.ruleForm.subtitulo_proposta="";
      }
      if(this.ruleForm.subtitulo_valores==null){
        this.ruleForm.subtitulo_valores="";
      }
      if(this.ruleForm.subtitulo_impostos==null){
        this.ruleForm.subtitulo_impostos="";
      }
      if(this.ruleForm.subtitulo_pagamento==null){
        this.ruleForm.subtitulo_pagamento="";
      }
      if(this.ruleForm.subtitulo_frete==null){
        this.ruleForm.subtitulo_frete="";
      }
      if(this.ruleForm.subtitulo_garantia==null){
        this.ruleForm.subtitulo_garantia="";
      }
      if(this.ruleForm.subtitulo_validade==null){
        this.ruleForm.subtitulo_validade="";
      }
      if(this.ruleForm.subtitulo_aceite==null){
        this.ruleForm.subtitulo_aceite="";
      }
      let dados = {
        proposta_id: this.proposta_id,
        proposta_projeto_id: this.$route.params.id,
        proposta_status: "R",
        pagina_paginaTipo: "C",
        pagina_pagina: "3",
         ///ordem dos dados = texto*ordem*slug*label*tipo //campos separados por * e mais campos por |
        pagina_dados: this.ruleForm.titulo_proposta+'*1*tituloproposta*titulo proposta*TC|'+this.ruleForm.subtitulo_proposta+'*2*subtituloproposta*subtitulo proposta*TC|'+this.ruleForm.proposta+'*1*proposta*PROPOSTA COMERCIAL*C|'+this.ruleForm.titulo_valores+'*3*titulovalores*titulo valores*TC|'+this.ruleForm.subtitulo_valores+'*4*subtitulovalores*subtitulo valores*TC|'+this.ruleForm.titulo_impostos+'*5*tituloimpostos*titulo impostos*TC|'+this.ruleForm.subtitulo_impostos+'*6*subtituloimpostos*subtitulo impostos*TC|'+this.ruleForm.impostos+'*2*impostos*IMPOSTOS*C|'+this.ruleForm.titulo_pagamento+'*7*titulopagamento*titulo pagamento*TC|'+this.ruleForm.subtitulo_pagamento+'*8*subtitulopagamento*subtitulo pagamento*TC|'+this.ruleForm.pagamento+'*3*pagamento*CONDIÇÕES DE PAGAMENTO*C|'+this.ruleForm.titulo_frete+'*9*titulofrete*titulo frete*TC|'+this.ruleForm.subtitulo_frete+'*10*subtitulofrete*subtitulo frete*TC|'+this.ruleForm.frete+'*4*frete*FRETE*C|'+this.ruleForm.titulo_garantia+'*11*titulogarantia*titulo garantia*TC|'+this.ruleForm.subtitulo_garantia+'*12*subtitulogarantia*subtitulo garantia*TC|'+this.ruleForm.garantia+'*5*garantia*GARANTIA*C|'+this.ruleForm.titulo_validade+'*13*titulovalidade*titulo validade*TC|'+this.ruleForm.subtitulo_validade+'*14*subtitulovalidade*subtitulo validade*TC|'+this.ruleForm.validade+'*6*validade*VALIDADE DA PROPOSTA*C|'+this.ruleForm.titulo_aceite+'*17*tituloaceite*titulo aceite*TC|'+this.ruleForm.subtitulo_aceite+'*18*subtituloaceite*subtitulo aceite*TC|'+this.ruleForm.titulo_entrega+'*15*tituloentrega*titulo entrega*TC|'+this.ruleForm.subtitulo_entrega+'*16*subtituloentrega*subtitulo entrega*TC|'+this.ruleForm.entrega+'*7*entrega*PRAZO DE ENTREGA*C|'+this.ruleForm.aceite+'*1*aceite*NBRTec*AC|'+this.ruleForm.aceite2+'*2*aceite2*Cliente*AC|',
      };

      axios
        .post(url + "/proposta/register/", dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          this.$notify({
            title: "Sucesso",
            message: "Registro salvo com Sucesso!",
            type: "success",
          });

          let prop;
          prop = resp.data["proposta"].id;
   
          let dado = {
            active: 4,
            proposta: prop,
          };
          this.$emit("button-click", dado);
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
        });        
      },      
      anterior() {
        let dado = {
          'active':2,
          'proposta':this.proposta_id,
        };        
        this.$emit('button-click',dado);
      }      
    }
};
</script>
<style>
#proposta_passo2 #proposta  {
  height: 200px;
  width: 100%;
} 
</style>